import { useState, useEffect } from "react";

const API = "https://surabaya-api.onrender.com/api/patrick";

const MEMBRES = {
  patrick:  { nom: "Patrick",  emoji: "🔧", couleur: "#f97316", role: "Maintenance" },
  christian:{ nom: "Christian",emoji: "👨‍🍳", couleur: "#4ade80", role: "Cuisine" },
  coralie:  { nom: "Coralie",  emoji: "🍽️", couleur: "#60a5fa", role: "Service" },
  mamat:    { nom: "Mamat",    emoji: "☕", couleur: "#e8c47c", role: "Patron — vue globale" },
};

const CATEGORIES = ["Panne", "Entretien", "Achat", "Travaux", "Constat", "Cuisine", "Service", "Autre"];
const STATUTS = {
  nouveau:           { label: "Nouveau",        color: "#e8c47c", bg: "#3d2a08" },
  en_cours:          { label: "En cours",        color: "#60a5fa", bg: "#1e3a5f" },
  en_attente_piece:  { label: "Attente pièce",   color: "#f97316", bg: "#3d1f08" },
  devis_demande:     { label: "Devis demandé",   color: "#c084fc", bg: "#2d1a4a" },
  termine:           { label: "Terminé",         color: "#4ade80", bg: "#1a3a1a" },
};
const DEMANDEURS = ["Mamat", "Christian", "Coralie", "Patrick"];
const BROWN = "#1a0f07";
const GOLD  = "#e8c47c";

export default function EquipePage() {
  const params = new URLSearchParams(window.location.search);
  const key = Object.keys(MEMBRES).find(k => params.has(k)) || "patrick";
  const membre = MEMBRES[key];
  const isPatron = key === "mamat";

  const [taches, setTaches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [vue, setVue] = useState("liste");
  const [filtre, setFiltre] = useState("actif");
  const [editId, setEditId] = useState(null);
  const [editData, setEditData] = useState({});
  const [form, setForm] = useState({
    titre: "", description: "", categorie: CATEGORIES[0],
    priorite: "normale", demandeur: "Mamat",
    assigne_a: membre.nom
  });

  const load = () => {
    setLoading(true);
    fetch(`${API}/taches`).then(r => r.json()).then(d => { setTaches(d); setLoading(false); }).catch(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  const tachesFiltrees = taches
    .filter(t => isPatron ? true : t.assigne_a === membre.nom)
    .filter(t => filtre === "actif" ? t.statut !== "termine" : filtre === "termine" ? t.statut === "termine" : true);

  const creer = async () => {
    if (!form.titre.trim()) return;
    await fetch(`${API}/taches`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(form) });
    setForm({ titre: "", description: "", categorie: CATEGORIES[0], priorite: "normale", demandeur: "Mamat", assigne_a: membre.nom });
    setVue("liste");
    load();
  };

  const maj = async (id, data) => {
    await fetch(`${API}/taches/${id}`, { method: "PATCH", headers: { "Content-Type": "application/json" }, body: JSON.stringify(data) });
    setEditId(null);
    load();
  };

  const supprimer = async (id) => {
    if (!window.confirm("Supprimer ?")) return;
    await fetch(`${API}/taches/${id}`, { method: "DELETE" });
    load();
  };

  const StatutBadge = ({ statut }) => {
    const s = STATUTS[statut] || STATUTS.nouveau;
    return <span style={{ fontSize: 11, fontWeight: 500, padding: "2px 8px", borderRadius: 20, background: s.bg, color: s.color }}>{s.label}</span>;
  };

  const TacheCard = ({ t }) => (
    <div style={{ background: "var(--color-background-primary)", border: t.priorite === "urgente" ? `1.5px solid #f97316` : "0.5px solid var(--color-border-tertiary)", borderRadius: 12, padding: "14px 16px", marginBottom: 10 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 8, marginBottom: 6 }}>
        <div style={{ flex: 1 }}>
          {t.priorite === "urgente" && <span style={{ fontSize: 11, color: "#f97316", fontWeight: 500, marginRight: 8 }}>🚨 URGENT</span>}
          <span style={{ fontSize: 14, fontWeight: 500, color: "var(--color-text-primary)" }}>{t.titre}</span>
          <span style={{ fontSize: 12, color: "var(--color-text-secondary)", marginLeft: 8 }}>{t.categorie}</span>
          {isPatron && <span style={{ fontSize: 11, marginLeft: 8, padding: "1px 7px", borderRadius: 20, background: MEMBRES[t.assigne_a?.toLowerCase()]?.couleur + "20" || "#fff", color: MEMBRES[t.assigne_a?.toLowerCase()]?.couleur || "#888" }}>{t.assigne_a}</span>}
        </div>
        <StatutBadge statut={t.statut} />
      </div>
      {t.description && <p style={{ fontSize: 13, color: "var(--color-text-secondary)", margin: "0 0 8px", lineHeight: 1.5 }}>{t.description}</p>}
      {t.commentaire_patrick && (
        <div style={{ background: "var(--color-background-secondary)", borderRadius: 8, padding: "8px 10px", marginBottom: 8, fontSize: 12, color: "var(--color-text-secondary)" }}>
          <strong style={{ color: "var(--color-text-primary)" }}>{t.assigne_a} :</strong> {t.commentaire_patrick}
        </div>
      )}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 6, marginTop: 8 }}>
        <span style={{ fontSize: 11, color: "var(--color-text-secondary)" }}>Par {t.demandeur} · {new Date(t.created_at).toLocaleDateString("fr-FR")}</span>
        <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
          {Object.entries(STATUTS).filter(([k]) => k !== t.statut).map(([k, v]) => (
            <button key={k} onClick={() => maj(t.id, { statut: k })} style={{ fontSize: 11, padding: "3px 8px", borderRadius: 20, border: `0.5px solid ${v.color}`, background: "transparent", color: v.color, cursor: "pointer" }}>{v.label}</button>
          ))}
          <button onClick={() => { setEditId(t.id); setEditData({ commentaire_patrick: t.commentaire_patrick || "" }); }} style={{ fontSize: 11, padding: "3px 8px", borderRadius: 20, border: "0.5px solid var(--color-border-secondary)", background: "transparent", color: "var(--color-text-secondary)", cursor: "pointer" }}>Commenter</button>
          <button onClick={() => supprimer(t.id)} style={{ fontSize: 11, padding: "3px 8px", borderRadius: 20, border: "0.5px solid #f87171", background: "transparent", color: "#f87171", cursor: "pointer" }}>✕</button>
        </div>
      </div>
      {editId === t.id && (
        <div style={{ marginTop: 10, display: "flex", gap: 8 }}>
          <input value={editData.commentaire_patrick} onChange={e => setEditData({ commentaire_patrick: e.target.value })} placeholder="Votre commentaire..." style={{ flex: 1, fontSize: 13, padding: "6px 10px", borderRadius: 8, border: "0.5px solid var(--color-border-secondary)", background: "var(--color-background-secondary)", color: "var(--color-text-primary)", outline: "none" }} />
          <button onClick={() => maj(t.id, editData)} style={{ fontSize: 13, padding: "6px 12px", borderRadius: 8, background: BROWN, color: GOLD, border: "none", cursor: "pointer" }}>OK</button>
          <button onClick={() => setEditId(null)} style={{ fontSize: 13, padding: "6px 12px", borderRadius: 8, background: "var(--color-background-secondary)", border: "0.5px solid var(--color-border-secondary)", cursor: "pointer" }}>✕</button>
        </div>
      )}
    </div>
  );

  const urgentes = tachesFiltrees.filter(t => t.priorite === "urgente");
  const normales = tachesFiltrees.filter(t => t.priorite !== "urgente");

  return (
    <div style={{ maxWidth: 720, margin: "0 auto", fontFamily: "var(--font-sans)", paddingBottom: "2rem" }}>
      <div style={{ background: BROWN, padding: "14px 20px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <div>
          <div style={{ color: membre.couleur, fontSize: 16, fontWeight: 500 }}>{membre.emoji} {membre.nom} · {membre.role}</div>
          <div style={{ color: "#8a6a40", fontSize: 12 }}>{tachesFiltrees.filter(t => t.statut !== "termine").length} tâche(s) en cours</div>
        </div>
        <button onClick={() => setVue(vue === "form" ? "liste" : "form")} style={{ background: GOLD, color: BROWN, border: "none", borderRadius: 20, padding: "7px 16px", fontSize: 13, fontWeight: 500, cursor: "pointer" }}>
          {vue === "form" ? "Annuler" : "+ Nouvelle tâche"}
        </button>
      </div>

      <div style={{ padding: "16px 20px" }}>
        {vue === "form" && (
          <div style={{ background: "var(--color-background-primary)", border: "0.5px solid var(--color-border-tertiary)", borderRadius: 12, padding: "16px", marginBottom: 16 }}>
            <input value={form.titre} onChange={e => setForm({ ...form, titre: e.target.value })} placeholder="Titre *" style={{ width: "100%", fontSize: 14, padding: "8px 12px", borderRadius: 8, border: "0.5px solid var(--color-border-secondary)", background: "var(--color-background-secondary)", color: "var(--color-text-primary)", outline: "none", marginBottom: 10, boxSizing: "border-box" }} />
            <textarea value={form.description} onChange={e => setForm({ ...form, description: e.target.value })} placeholder="Description (optionnel)" rows={2} style={{ width: "100%", fontSize: 13, padding: "8px 12px", borderRadius: 8, border: "0.5px solid var(--color-border-secondary)", background: "var(--color-background-secondary)", color: "var(--color-text-primary)", outline: "none", resize: "none", marginBottom: 10, boxSizing: "border-box", fontFamily: "var(--font-sans)" }} />
            <div style={{ display: "grid", gridTemplateColumns: isPatron ? "1fr 1fr 1fr 1fr" : "1fr 1fr 1fr", gap: 8, marginBottom: 12 }}>
              <select value={form.categorie} onChange={e => setForm({ ...form, categorie: e.target.value })} style={{ fontSize: 13, padding: "7px 10px", borderRadius: 8, border: "0.5px solid var(--color-border-secondary)", background: "var(--color-background-secondary)", color: "var(--color-text-primary)" }}>
                {CATEGORIES.map(c => <option key={c}>{c}</option>)}
              </select>
              <select value={form.priorite} onChange={e => setForm({ ...form, priorite: e.target.value })} style={{ fontSize: 13, padding: "7px 10px", borderRadius: 8, border: "0.5px solid var(--color-border-secondary)", background: "var(--color-background-secondary)", color: "var(--color-text-primary)" }}>
                <option value="normale">Normale</option>
                <option value="urgente">🚨 Urgente</option>
              </select>
              <select value={form.demandeur} onChange={e => setForm({ ...form, demandeur: e.target.value })} style={{ fontSize: 13, padding: "7px 10px", borderRadius: 8, border: "0.5px solid var(--color-border-secondary)", background: "var(--color-background-secondary)", color: "var(--color-text-primary)" }}>
                {DEMANDEURS.map(d => <option key={d}>{d}</option>)}
              </select>
              {isPatron && (
                <select value={form.assigne_a} onChange={e => setForm({ ...form, assigne_a: e.target.value })} style={{ fontSize: 13, padding: "7px 10px", borderRadius: 8, border: "0.5px solid var(--color-border-secondary)", background: "var(--color-background-secondary)", color: "var(--color-text-primary)" }}>
                  {Object.values(MEMBRES).map(m => <option key={m.nom}>{m.nom}</option>)}
                </select>
              )}
            </div>
            <button onClick={creer} disabled={!form.titre.trim()} style={{ width: "100%", padding: "10px", borderRadius: 8, background: form.titre.trim() ? BROWN : "var(--color-background-secondary)", color: form.titre.trim() ? GOLD : "var(--color-text-secondary)", border: "none", cursor: form.titre.trim() ? "pointer" : "default", fontSize: 14, fontWeight: 500 }}>
              Créer la tâche
            </button>
          </div>
        )}

        <div style={{ display: "flex", gap: 8, marginBottom: 16 }}>
          {[["actif", "En cours"], ["termine", "Terminées"], ["tout", "Tout"]].map(([k, l]) => (
            <button key={k} onClick={() => setFiltre(k)} style={{ fontSize: 12, padding: "5px 12px", borderRadius: 20, border: `0.5px solid ${filtre === k ? GOLD : "var(--color-border-tertiary)"}`, background: filtre === k ? BROWN : "transparent", color: filtre === k ? GOLD : "var(--color-text-secondary)", cursor: "pointer" }}>{l}</button>
          ))}
        </div>

        {loading ? <p style={{ color: "var(--color-text-secondary)", fontSize: 14 }}>Chargement...</p> : (
          <>
            {urgentes.length > 0 && <div style={{ marginBottom: 16 }}>
              <p style={{ fontSize: 11, fontWeight: 500, color: "#f97316", textTransform: "uppercase", letterSpacing: "0.06em", margin: "0 0 8px" }}>Urgentes</p>
              {urgentes.map(t => <TacheCard key={t.id} t={t} />)}
            </div>}
            {normales.length > 0 && <div>
              {urgentes.length > 0 && <p style={{ fontSize: 11, fontWeight: 500, color: "var(--color-text-secondary)", textTransform: "uppercase", letterSpacing: "0.06em", margin: "0 0 8px" }}>Normales</p>}
              {normales.map(t => <TacheCard key={t.id} t={t} />)}
            </div>}
            {tachesFiltrees.length === 0 && <p style={{ color: "var(--color-text-secondary)", fontSize: 14, textAlign: "center", padding: "2rem 0" }}>Aucune tâche {filtre === "actif" ? "en cours" : filtre === "termine" ? "terminée" : ""}.</p>}
          </>
        )}
      </div>
    </div>
  );
}
